(function () {
  'use strict';

  var CARD_SELECTOR = [
    '.products-list .box.product',
    '.products .box.product',
    '.search-results .box.product',
    '.collection .box.product',
    '.product-card',
    '.product-item',
    '[data-product-handle]',
    '[data-product-id]'
  ].join(', ');

  var COLOR_MAP = {
    'WB': '#98c33c',
    'IHC-P': '#ebc138',
    'IHC-F': '#ee644a',
    'IF(IHC-P)': '#2cd4bf',
    'IF(IHC-F)': '#ff62a4',
    'IF(ICC)': '#004aad',
    'ELISA': '#73caee',
    'FCM': '#ff3131'
  };

  var FALLBACK_COLOR = '#4C2C6C';
  var RESCAN_DELAY_MS = 150;
  var PERIODIC_RESCAN_MS = 1500;
  var PERIODIC_RESCAN_LIMIT_MS = 120000;
  var startedAt = Date.now();
  var scanTimer = null;

  function normalizeText(text) {
    return (text || '').replace(/&nbsp;/gi, ' ').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function absolutizeProductUrl(url) {
    if (!url) return '';
    url = String(url).split('#')[0].trim();
    var match = url.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? '/products/' + match[1] : '';
  }

  function productUrlFromCard(card) {
    if (!card) return '';

    var direct = card.getAttribute('data-product-url') || card.getAttribute('data-url');
    if (direct && direct.indexOf('/products/') !== -1) return absolutizeProductUrl(direct);

    var handle = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    if (handle) return '/products/' + String(handle).replace(/^\/products\//, '').replace(/^\//, '').split(/[?#]/)[0];

    var imageSlot = card.querySelector('[data-bioss-product-card-image], .bioss-card-image-loader, .bioss-card-image-injected');
    if (imageSlot) {
      var slotUrl = imageSlot.getAttribute('data-product-url');
      if (slotUrl && slotUrl.indexOf('/products/') !== -1) return absolutizeProductUrl(slotUrl);

      var endpoint = imageSlot.getAttribute('data-images-endpoint') || '';
      if (endpoint && endpoint.indexOf('/products/') !== -1) return absolutizeProductUrl(endpoint);
    }

    var link = card.querySelector('a.product-title[href], header a[href*="/products/"], h1 a[href*="/products/"], h2 a[href*="/products/"], h3 a[href*="/products/"], a[href*="/products/"]');
    if (!link) return '';

    var href = link.getAttribute('href') || '';
    if (href.indexOf('/products/') === -1) return '';
    return absolutizeProductUrl(href);
  }

  function normalizeApplicationKey(text) {
    return normalizeText(text)
      .replace(/[（]/g, '(')
      .replace(/[）]/g, ')')
      .replace(/\s+/g, '')
      .toUpperCase();
  }

  function appClass(label) {
    return 'app_' + normalizeApplicationKey(label)
      .toLowerCase()
      .replace(/[()]/g, '')
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function applicationColor(label) {
    return COLOR_MAP[normalizeApplicationKey(label)] || FALLBACK_COLOR;
  }

  function splitApplications(text) {
    text = normalizeText(text).replace(/^Applications?\s*:\s*/i, '');
    if (!text) return [];

    return text.split(',')
      .map(function (item) { return normalizeText(item); })
      .filter(function (item) { return item && item !== '-'; });
  }

  function createPills(applications, productUrl) {
    if (!applications || !applications.length) return null;

    var wrap = document.createElement('div');
    wrap.className = 'bioss-card-application-pills';
    wrap.setAttribute('data-bioss-card-application-pills', 'true');
    wrap.setAttribute('aria-label', 'Applications');

    for (var i = 0; i < applications.length; i += 1) {
      var label = applications[i];
      var pill = document.createElement(productUrl ? 'a' : 'span');
      pill.className = 'bioss-card-application-pill ' + appClass(label);
      pill.setAttribute('data-bioss-app-label', label);
      pill.textContent = label;
      pill.style.backgroundColor = applicationColor(label);

      if (productUrl) {
        pill.href = productUrl;
        pill.setAttribute('aria-label', label + ' application for this product');
        pill.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }

      wrap.appendChild(pill);
    }

    return wrap;
  }

  function colorExistingCardPills(root) {
    root = root || document;
    var pills = root.querySelectorAll('.bioss-card-application-pill');
    for (var i = 0; i < pills.length; i += 1) {
      var pill = pills[i];
      var label = pill.getAttribute('data-bioss-app-label') || pill.textContent || '';
      pill.style.backgroundColor = applicationColor(label);
      pill.setAttribute('data-bioss-app-pill-color', applicationColor(label));
    }
  }

  function descriptionContainer(card) {
    return card.querySelector('.description.rte, .description, figcaption, .product-card__info, .product-item__info') || card;
  }

  function findApplicationRow(container) {
    if (!container || !container.querySelectorAll) return null;

    var candidates = container.querySelectorAll('p, li, div');
    for (var i = 0; i < candidates.length; i += 1) {
      var el = candidates[i];
      if (!el || el.classList.contains('bioss-card-application-pills')) continue;
      if (el.closest && el.closest('.bioss-card-application-pills')) continue;
      if (el.closest && el.closest('.product-details')) continue;

      var text = normalizeText(el.textContent || '');
      if (!/^Applications?\s*:/i.test(text)) continue;

      // Avoid replacing a larger wrapper that contains multiple metadata rows.
      if (/\bCatalog\s*#/i.test(text) || /\bReactivity\s*:/i.test(text) || /\bConjugate\s*:/i.test(text)) continue;

      return el;
    }

    return null;
  }

  function replaceApplicationTextWithPills(card) {
    if (!card) return;
    var container = descriptionContainer(card);
    if (!container) return;

    colorExistingCardPills(container);

    if (container.querySelector('.bioss-card-application-pills')) return;

    var row = findApplicationRow(container);
    if (!row) return;

    var applications = splitApplications(row.textContent || '');
    if (!applications.length) return;

    var productUrl = productUrlFromCard(card);
    var pills = createPills(applications, productUrl);
    if (!pills) return;

    if (row.parentNode) {
      row.parentNode.replaceChild(pills, row);
    }
  }

  function scanCards() {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i += 1) {
      replaceApplicationTextWithPills(cards[i]);
    }
    colorExistingCardPills(document);
  }

  function scheduleScan() {
    if (scanTimer) window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      scanTimer = null;
      scanCards();
    }, RESCAN_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCards);
  } else {
    scanCards();
  }

  window.addEventListener('load', scheduleScan);

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () { scheduleScan(); });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  var periodic = window.setInterval(function () {
    if (Date.now() - startedAt > PERIODIC_RESCAN_LIMIT_MS) {
      window.clearInterval(periodic);
      return;
    }
    scheduleScan();
  }, PERIODIC_RESCAN_MS);
})();
